/**
 * The responsbility of this component is to provide a modal that allows the user to crop an image.
 * The user can crop the image using the cropper and then click the crop button to get the cropped image.
 * The cropped image is then passed to the parent component using the onCropComplete callback.
 */

import React, { useRef } from 'react';

// Proptypes
import PropTypes from 'prop-types';

// Import the Cropper component for image cropping & cropper styles
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';

// Import MUI Joy components for the modal
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogContent from '@mui/joy/DialogContent';
import Button from '@mui/joy/Button';

// CropImage component that handles image cropping functionality
export default function CropImage({
    image,
    isOpen,
    onClose,
    width = 320,
    height = 320,
    onCropComplete,
    aspectRatio = 1
}) {
    // Reference to the cropper instance
    const cropperRef = useRef(null);

    // Handler function for when crop button is clicked
    // function handleCrop() {
    //     // Check if cropper instance exists
    //     if (cropperRef.current?.cropper) {
    //         // Get the cropped canvas with specified dimensions
    //         const canvas = cropperRef.current?.cropper.getCroppedCanvas({
    //             width: width,
    //             height: height
    //         });

    //         // If canvas is created successfully
    //         if (canvas) {
    //             // Convert canvas to blob (binary data)
    //             canvas.toBlob((blob) => {
    //                 // Create a URL for the blob
    //                 const croppedImageUrl = URL.createObjectURL(blob);
    //                 // Call the completion callback if provided
    //                 if (onCropComplete) {
    //                     onCropComplete(croppedImageUrl, blob);
    //                 }
    //                 onClose(); // Close the modal
    //             }, 'image/jpeg');
    //         }
    //     }
    // }

    function handleCrop() {
        if (cropperRef.current?.cropper) {
            const canvas = cropperRef.current.cropper.getCroppedCanvas({
                width: width,
                height: height
            });

            if (canvas) {
                canvas.toBlob((blob) => {
                    if (blob) {
                        // Convert blob to File
                        const file = new File([blob], 'cropped-image.jpg', {
                            type: 'image/jpeg',
                            lastModified: Date.now()
                        });

                        // Send both preview URL and file
                        const croppedImageUrl = URL.createObjectURL(file);

                        if (onCropComplete) {
                            onCropComplete({
                                file,
                                previewUrl: croppedImageUrl
                            });
                        }

                        onClose();
                    }
                }, 'image/jpeg');
            }
        }
    }

    return (
        // Modal component that contains the cropper
        <Modal open={isOpen} onClose={onClose}>
            <ModalDialog sx={{ borderRadius: '1rem', overflow: 'hidden' }} variant="soft">
                <ModalClose
                    sx={{
                        top: '2px',
                        right: '3px',
                        zIndex: '100',
                        backgroundColor: 'transparent',
                        '&:hover': {
                            backgroundColor: 'transparent'
                        }
                    }}
                />
                <DialogContent sx={{ gap: '0rem' }}>
                    <Cropper
                        src={image}
                        viewMode={1}
                        guides={true}
                        center={true}
                        dragMode="move"
                        autoCropArea={1}
                        ref={cropperRef}
                        background={false}
                        cropBoxMovable={false}
                        checkOrientation={true}
                        cropBoxResizable={false}
                        aspectRatio={aspectRatio}
                        style={{ height: '50vh', width: '526px', margin: '0.5rem' }}
                    />
                    <Button onClick={handleCrop}>Crop Image</Button>
                </DialogContent>
            </ModalDialog>
        </Modal>
    );
}

// PropTypes for props validation
CropImage.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    image: PropTypes.string.isRequired,
    aspectRatio: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    onCropComplete: PropTypes.func.isRequired
};

// // If canvas is created successfully
// if (canvas) {
//     // Convert canvas to file directly
//     canvas.toBlob((blob) => {
//         const file = new File([blob], 'cropped-image.jpg', { type: 'image/jpeg' });
//         // Call the completion callback if provided
//         if (onCropComplete) {
//             onCropComplete(file);
//         }
//         onClose(); // Close the modal
//     }, 'image/jpeg');
// }
